import React from 'react';

type AlertIconProps = {
  width?: number;
  height?: number;
  fill?: string;
};

export const AlertIcon: React.FC<AlertIconProps> = ({ width = 24, height = 24, fill = 'white' }) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={width} height={height} viewBox='0 0 24 24' fill='none'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12 2.79995C6.91893 2.79995 2.79995 6.91893 2.79995 12C2.79995 17.081 6.91893 21.2 12 21.2C17.081 21.2 21.2 17.081 21.2 12C21.2 6.91893 17.081 2.79995 12 2.79995ZM1.19995 12C1.19995 6.03528 6.03528 1.19995 12 1.19995C17.9646 1.19995 22.7999 6.03528 22.7999 12C22.7999 17.9646 17.9646 22.7999 12 22.7999C6.03528 22.7999 1.19995 17.9646 1.19995 12Z'
      fill={fill}
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12 7.19995C12.4418 7.19995 12.8 7.55812 12.8 7.99995V12C12.8 12.4418 12.4418 12.8 12 12.8C11.5581 12.8 11.2 12.4418 11.2 12V7.99995C11.2 7.55812 11.5581 7.19995 12 7.19995Z'
      fill={fill}
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M11 16C11 15.4477 11.4477 15 12 15H12.01C12.5622 15 13.01 15.4477 13.01 16C13.01 16.5522 12.5622 17 12.01 17H12C11.4477 17 11 16.5522 11 16Z'
      fill={fill}
    />
  </svg>
);
